export default class ViewerThumbList {
    constructor(id, direction) {
        const self = this;

        this._list = document.getElementById(id);
        this._direction = direction;

        this._list.addEventListener('mouseover', this._mouseOverEventHandler, false);
        this._list.addEventListener('mouseout', this._mouseOutEventHandler, false);
        if (this._direction === 'row') this._list.addEventListener('wheel', this._mouseWheelEventHandler, false);

        this._thumbList = this._list.children;
        Array.prototype.forEach.call(this._thumbList, function (thumb) {
            thumb.addEventListener('click', self._clickThumbEventHandler.bind(self), false);
        });
    }

    /**
         * マウスオーバー時のイベントハンドラ。
         * 要素にフォーカスを当てます。
         * @param {MouseEvent} event マウスイベント。
         */
    _mouseOverEventHandler(event) {
        event.currentTarget.focus();
    }

    /**
     * マウスアウト時のイベントハンドラ。
     * 要素からフォーカスを外します。
     * @param {MouseEvent} event マウスイベント。
     */
    _mouseOutEventHandler(event) {
        event.currentTarget.blur();
    }

    /**
     * マウスホイールイベントのイベントハンドラ。
     * @param {WheelEvent} event マウスホイールイベント。
     */
    _mouseWheelEventHandler(event) {

        const target = event.currentTarget;

        // deltaYが0でない場合(=上下のスクロール)の場合は横スクロールに置き換える。
        if (event.deltaY !== 0) {
            event.preventDefault();

            const deltaY = event.deltaY > 0 ? 1 : -1;
            const scrollVal = target.dataset.pageDirection === 'rtl' ? -1 * deltaY * 128 : deltaY * 128;

            if (HTMLUListElement.prototype.scrollBy) {
                target.scrollBy({
                    top: 0,
                    left: scrollVal,
                    behavior: 'auto',
                });
            }
            else {
                target.scrollLeft = target.scrollLeft - scrollVal;
            }
        }
    }

    _clickThumbEventHandler(event) {

        const target = event.currentTarget;
        const self = this;
        Array.prototype.forEach.call(this._thumbList, function (thumb) {
            if (target === thumb) {
                thumb.classList.add('selected');
                self.scrollIntoView(thumb);
            }
            else {
                thumb.classList.remove('selected');
            }
        });
    }

    /**
    * サムネイルの状態を変更します。
    * @param {Number} page ページ番号。
    */
    changePage(page) {

        const self = this;
        Array.prototype.forEach.call(this._thumbList, function (thumb) {
            const thumbPage = parseInt(thumb.dataset.pageNumber);

            if (page === thumbPage) {
                thumb.classList.add('selected');
                self.scrollIntoView(thumb);
            }
            else {
                thumb.classList.remove('selected');
            }
        });
    }

    /**
     * 指定された要素の位置までスクロールします。
     * @param {HTMLElement} element エレメント
     */
    scrollIntoView(element) {

        const clientRect = element.getBoundingClientRect();
        const parentRect = this._list.getBoundingClientRect();

        if (this._direction === 'column') {
            const scrollTop = clientRect.top - parentRect.top - 10;
            if (HTMLUListElement.prototype.scrollBy) {
                this._list.scrollBy({
                    top: scrollTop,
                    left: 0,
                    behavior: 'smooth',
                });
            }
            else {
                this._list.scrollTop = this._list.scrollTop - scrollTop;
            }
        }
        else {
            const scrollLeft = clientRect.left - parentRect.left - (parentRect.width / 2) + (clientRect.width / 2);
            if (HTMLUListElement.prototype.scrollBy) {
                this._list.scrollBy({
                    top: 0,
                    left: scrollLeft,
                    behavior: 'smooth',
                });
            }
            else {
                this._list.scrollLeft = this._list.scrollLeft - scrollLeft;
            }
        }
    }
}